

module.exports = {
  cleanNewlines: function cleanNewlines(input) {
    return input.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-compiler/dist/es/processors/pre.js
// module id = 990
// module chunks = 0